import React, { FC, useState, useEffect, memo } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import LotSelect from "../../ui/lotSelect";
import MyTextInput from "../../ui/myTextInput";
import './catChuyen.scss'
import { getLocalKeyCatKhoang, StateKHoang } from "./catchuyenlib";
type OwnProps = {
    chuId: number;
    onConfirm: (params: any) => void;
    onPlayOn789: (params: any) => void;
}



const ChuyenTheoKhoang: FC<OwnProps> = ({
    chuId,
    onConfirm,
    onPlayOn789,

}: OwnProps) => {
    const [state, setState] = useState<StateKHoang>({
        chuId: chuId,
        catItems: [{ tu: 1, den: 100, diem: 100, dvt: '%' }],

    });
    function addItem() {
        const tmp = [...state.catItems];
        tmp.push({ tu: 1, den: 100, diem: 100, dvt: '%' });
        setState({ ...state, catItems: tmp });
    }
    function removeIem(index: number) {

        const tmp = [...state.catItems];
        tmp.splice(index, 1);
        setState({ ...state, catItems: tmp });
    }
    function handleTuChange(index: number, value: string) {
        if (isNaN(parseInt(value))) {
            return;
        }
        const tmp = [...state.catItems];
        tmp[index].tu = parseInt(value);
        setState({ ...state, catItems: tmp });
    }
    function handleDenChange(index: number, value: string) {
        if (isNaN(parseInt(value))) {
            return;
        }
        const tmp = [...state.catItems];
        tmp[index].den = parseInt(value);
        setState({ ...state, catItems: tmp });
    }
    function handleDiemChange(index: number, value: string) {
        if (isNaN(parseInt(value))) {
            return;
        }
        const tmp = [...state.catItems];
        tmp[index].diem = parseInt(value);
        setState({ ...state, catItems: tmp });
    }
    function handleDvtChange(index: number, value: string) {
        const tmp = [...state.catItems];
        tmp[index].dvt = value;
        setState({ ...state, catItems: tmp });
    }
    function saveCatKhoangToLocal() {
        const key = getLocalKeyCatKhoang(state.chuId);
        localStorage[key] = JSON.stringify(state);
    }
    useEffect(() => {
        const key = getLocalKeyCatKhoang(state.chuId);
        const saved = localStorage[key];
        if (saved) {
            const savedObject = JSON.parse(saved);
            setState(prev => ({ ...prev, ...savedObject }));
        }
    }, [chuId]);
    const length = state.catItems.length;
    return (
        <div className="dialog-content">
            {state.catItems.map((item, index) => {
                return <>
                    <div className=" cat-item" key={index}>
                        <MyTextInput label="Từ" id={`${index}-tu`}
                            value={item.tu}
                            onChange={(e) => handleTuChange(index, e.target.value)} />
                        <MyTextInput label="Đến" id={`${index}-den`}
                            value={item.den}
                            onChange={(e) => handleDenChange(index, e.target.value)} />
                        <MyTextInput label="Điểm" id={`${index}-diem`}
                            value={item.diem}
                            onChange={(e) => handleDiemChange(index, e.target.value)} />
                        <LotSelect  id={`${index}-dvt`}
                             
                            value={item.dvt}
                            onChange={(e) => handleDvtChange(index, e.target.value)} >
                                <option value='%' selected={item.dvt=='%'}>%</option>
                                <option value='điểm' selected={item.dvt!='%'}>điểm</option>
                            </LotSelect>
                        {
                            index > 0 ?
                                <button
                                    onClick={() => removeIem(index)}
                                    className="add-remove-item"
                                >-</button>
                                : <div></div>
                        }

                        {
                            index == length - 1 ?
                                <button onClick={() => addItem()}
                                    className="add-remove-item"
                                >+</button>
                                : <div></div>
                        }
                    </div>
                </>
            })}
            <div className=" common-container-col" style='gap:5px;'>
                <Button onClick={() => {
                    const tmp = [...state.catItems];
                    const params = { chuId: chuId, catItems: tmp }
                    saveCatKhoangToLocal();
                    onConfirm(params);
                }} size="smaller">Chuyển</Button>
                <Button onClick={() => {
                    const tmp = [...state.catItems];
                    const params = { chuId: chuId, catItems: tmp }
                    saveCatKhoangToLocal();
                    onPlayOn789(params);
                }} size="smaller">Chuyển one789</Button>
            </div>
        </div>
    )
}

export default memo(ChuyenTheoKhoang);